module.exports = __webpack_public_path__ + "static/media/logo-siem.33606e5e.svg";